import "@fontsource-variable/roboto-flex/opsz.css";
import "./antd.css";
import "./index.css";

import { StyleProvider } from "@ant-design/cssinjs";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { ThemeConfigProvider } from "./components/ThemeConfigProvider/ThemeConfigProvider";
import { App } from "./App";
import reportWebVitals from "./reportWebVitals";
import store from "./store/Store";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

// не трогать говной воняет
if (window.location.pathname !== "/login") {
  localStorage.setItem("url", window.location.pathname);
}

root.render(
  <StyleProvider layer>
    <Provider store={store}>
      <BrowserRouter>
        <ThemeConfigProvider>
          <App />
        </ThemeConfigProvider>
      </BrowserRouter>
    </Provider>
  </StyleProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
